import { render } from "./device-details-history.vue?vue&type=template&id=642dbc50&scoped=true&ts=true"
import script from "./device-details-history.ts?vue&type=script&lang=ts"
export * from "./device-details-history.ts?vue&type=script&lang=ts"

import "./device-details-history.scss?vue&type=style&index=0&id=642dbc50&scoped=true&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642dbc50"]])

export default __exports__